/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const createContactsBatchHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Per-item creation results, in submitted order
 */
export const createContactsBatch201Schema = z.array(z.object({
    "id": z.nullable(z.string()),
"externalId": z.nullable(z.string()),
"inserted": z.boolean(),
"reason": z.optional(z.enum(["cap", "conflict"]))
    }))

/**
 * @description Invalid body
 */
export const createContactsBatch400Schema = z.any()

export const createContactsBatchMutationRequestSchema = z.array(z.object({
    "name": z.optional(z.string()),
"title": z.optional(z.string()),
"email": z.optional(z.string()),
"phone": z.optional(z.string()),
"company": z.optional(z.string()),
"location": z.optional(z.string()),
"socialMedia": z.optional(z.object({
    
    }).catchall(z.string())),
"externalId": z.optional(z.uuid())
    })).min(1).max(100)

export const createContactsBatchMutationResponseSchema = z.lazy(() => createContactsBatch201Schema)